import { render, staticRenderFns } from "./external-specs.vue?vue&type=template&id=d0970996&scoped=true&"
import script from "./external-specs.vue?vue&type=script&lang=js&"
export * from "./external-specs.vue?vue&type=script&lang=js&"
import style0 from "./external-specs.vue?vue&type=style&index=0&id=d0970996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0970996",
  null
  
)

export default component.exports